import React from 'react';
import BookingControllerRules from '../../components/travel/BookingControllerRules';

const BookingControllerMaster = () => {
  return (
    <div className="p-6 space-y-6 max-w-[1600px] mx-auto font-sans">
      <BookingControllerRules />
    </div>
  );
};

export default BookingControllerMaster;
